import React from 'react';
import { Link } from 'react-router-dom';

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch(error, errorInfo) {
    console.error('ErrorBoundary caught:', error, errorInfo);
  }

  render() {
    if (this.state.hasError) {
      return (
        <div style={{
          display: 'flex', flexDirection: 'column', alignItems: 'center',
          justifyContent: 'center', minHeight: '60vh', textAlign: 'center', padding: '2rem',
        }}>
          <h1 style={{ fontSize: '2rem', color: '#111827', marginBottom: '0.5rem' }}>Something went wrong</h1>
          <p style={{ color: '#6B7280', marginBottom: '2rem', maxWidth: '400px' }}>
            An unexpected error occurred. Please try refreshing the page.
          </p>
          <div style={{ display: 'flex', gap: '1rem' }}>
            <button
              onClick={() => window.location.reload()}
              style={{
                backgroundColor: '#0a74da', color: '#fff', padding: '0.75rem 1.5rem',
                borderRadius: '30px', border: 'none', fontWeight: 600, cursor: 'pointer',
              }}
            >
              Refresh Page
            </button>
            <Link to="/" style={{
              backgroundColor: 'transparent', color: '#0a74da', padding: '0.75rem 1.5rem',
              borderRadius: '30px', border: '2px solid #0a74da', textDecoration: 'none', fontWeight: 600,
            }}
            onClick={() => this.setState({ hasError: false })}
            >
              Back to Home
            </Link>
          </div>
        </div>
      );
    }
    return this.props.children;
  }
}

export default ErrorBoundary;
